/* QrPass.js */
import "./style.css";
// import bannerImg from "./qr-banner.png";
// import qrCode from "./qr-code.svg";
import send from "./Send.svg";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";
import {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Spinner } from "react-bootstrap";
import { ReactComponent as MyIcon } from "../../../icons/abhi-icons/Download.svg";
import { ReactComponent as SendIcon } from "../../../icons/abhi-icons/Send.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { getImageUrl } from "../../pages/Artist/ArtistAvatar";
import { toast } from "react-toastify";
import { apiCaller } from "../../../services/AxiosInstance";
import { updateAudienceApi } from "../../../services/AudienceService";
import { useSelector } from "react-redux";
import logoImg from "../../../images/logoart.png";
import torentImg from "../../../images/torrent.png";

const QrPass = forwardRef(
  (
    {
      name,
      fullName,
      ticketId,
      memberCount,
      btnTxt,
      qr,
      audienceData,
      customImage = false,
      previewImageUrl = null,
      allowBtns = true,
    },
    ref
  ) => {
    const qrPassRef = useRef();
    const [loading, setLoading] = useState(false);
    const [waloading, setWaLoading] = useState(false);
    const [invitationLoading, setInvitationLoading] = useState(false);
    const [orgNameFontSize, setOrgNameFontSize] = useState(14);
    const nameLineClass = memberCount ? "single-line" : "multi-line";
    const navigate = useNavigate();
    const location = useLocation();
    const data = useSelector((state) => state.systemconfig);

    // Determine background color based on audience type
    const getBackgroundColor = () => {
      const audienceType = audienceData?.audience_type;
      if (audienceType === "group") {
        return "#8B1E1E"; // Red color for group audience
      }
      return "#3A2625"; // Default brown color for normal audience
    };

    const backgroundColor = getBackgroundColor();

    // Dynamic font size calculation for organization name
    useEffect(() => {
      if (
        audienceData?.audience_type === "group" &&
        audienceData?.organization_name
      ) {
        const orgName = audienceData.organization_name;
        const maxWidth = 110; // Max width in pixels
        const baseFontSize = 14;

        // Create a temporary element to measure text width
        const tempElement = document.createElement("span");
        tempElement.style.fontSize = `${baseFontSize}px`;
        tempElement.style.fontWeight = "normal";
        tempElement.style.visibility = "hidden";
        tempElement.style.position = "absolute";
        tempElement.style.whiteSpace = "nowrap";
        tempElement.textContent = orgName;
        document.body.appendChild(tempElement);

        let currentFontSize = baseFontSize;
        let textWidth = tempElement.offsetWidth;

        // Decrease font size by 2px until text fits or reaches minimum size
        while (textWidth > maxWidth && currentFontSize > 8) {
          currentFontSize -= 1;
          tempElement.style.fontSize = `${currentFontSize}px`;
          textWidth = tempElement.offsetWidth;
        }

        document.body.removeChild(tempElement);
        setOrgNameFontSize(currentFontSize);
      }
    }, [audienceData?.organization_name, audienceData?.audience_type]);

    const handleDownload = async () => {
      if (qrPassRef.current === null) return;

      try {
        setLoading(true);

        // Temporarily hide the pseudo-elements (cutouts) for download
        const qrPassElement = qrPassRef.current;
        const originalBeforeDisplay =
          qrPassElement.style.getPropertyValue("--hide-pseudo");

        // Hide the cutouts
        qrPassElement.style.setProperty("--hide-pseudo", "none");

        // Capture the image without cutouts at 3x resolution for better quality
        const dataUrl = await toPng(qrPassElement, {
          cacheBust: true,
          backgroundColor: backgroundColor, // Use dynamic background color based on audience type
          pixelRatio: 3, // 3x resolution for high quality (269x292 becomes 807x876)
        });

        // Restore the cutouts for display
        qrPassElement.style.setProperty(
          "--hide-pseudo",
          originalBeforeDisplay || "block"
        );

        // Generate dynamic filename with name, mobile, and date-time
        const generateFileName = () => {
          const firstName = audienceData?.firstname || "Unknown";
          const mobile = audienceData?.mobile || "0000000000";
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");

          return `QR_Pass_${firstName}_${mobile}_${year}_${month}_${day}_${hours}_${minutes}.png`;
        };

        const link = document.createElement("a");
        link.download = generateFileName();
        link.href = dataUrl;
        link.click();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Failed to download:", error);
      }
    };

    // Reusable function to get or generate QR pass image URL
    const getOrGenerateQRPassImageUrl = async () => {
      if (qrPassRef.current === null) return null;

      try {
        let qrPassImageUrl = audienceData?.qr_pass_image_url;

        // If QR pass image URL doesn't exist, generate and upload it
        if (!qrPassImageUrl) {
          // Temporarily hide the pseudo-elements (cutouts) for download
          const qrPassElement = qrPassRef.current;
          const originalBeforeDisplay =
            qrPassElement.style.getPropertyValue("--hide-pseudo");

          // Hide the cutouts
          qrPassElement.style.setProperty("--hide-pseudo", "none");

          // Capture the image without cutouts at 3x resolution for better quality
          const dataUrl = await toPng(qrPassElement, {
            cacheBust: true,
            backgroundColor: backgroundColor, // Use dynamic background color based on audience type
            pixelRatio: 3, // 3x resolution for high quality (269x292 becomes 807x876)
          });

          // Restore the cutouts for display
          qrPassElement.style.setProperty(
            "--hide-pseudo",
            originalBeforeDisplay || "block"
          );

          // Generate dynamic filename with name, mobile, and date-time
          const generateFileName = () => {
            const firstName = audienceData?.firstname || "Unknown";
            const mobile = audienceData?.mobile || "0000000000";
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");

            return `QR_Pass_${firstName}_${mobile}_${year}_${month}_${day}_${hours}_${minutes}.png`;
          };

          const res = await fetch(dataUrl);
          const blob = await res.blob();

          const formData = new FormData();
          formData.append("file", blob, generateFileName());
          formData.append("audienceId", audienceData?._id || "");

          const imageUpload = await apiCaller({
            method: "post",
            url: "upload",
            params: null,
            data: formData,
          });

          if (imageUpload?.data?.data?.url) {
            qrPassImageUrl = imageUpload.data.data.url;

            // Update audience data with the QR pass image URL
            // Only send the qr_pass_image_url field to avoid triggering validation errors
            if (audienceData?._id) {
              try {
                await updateAudienceApi(
                  {
                    _id: audienceData._id,
                    qr_pass_image_url: qrPassImageUrl,
                  },
                  audienceData._id
                );

                // Update the local audienceData reference so subsequent checks use the updated URL
                if (audienceData) {
                  audienceData.qr_pass_image_url = qrPassImageUrl;
                }
              } catch (updateError) {
                console.error(
                  "Failed to update audience with QR pass image URL:",
                  updateError
                );
                // Continue with WhatsApp send even if update fails
              }
            }
          } else {
            toast.error("Unable to upload QR pass image.");
            return null;
          }
        }

        return qrPassImageUrl;
      } catch (error) {
        console.error("Failed to generate QR pass image:", error);
        return null;
      }
    };

    // Expose the ref and generate function to parent component
    useImperativeHandle(ref, () => ({
      getElement: () => qrPassRef.current,
      generateQRPassImage: getOrGenerateQRPassImageUrl,
    }));

    // Function to send special invitation image to WhatsApp
    const sendSpecialInvitationImage = async () => {
      try {
        await apiCaller({
          method: "post",
          url: `/audience/send-special-invitation-image-to-whatsapp/${audienceData?._id}`,
          params: null,
          data: null,
        });
        return true;
      } catch (error) {
        console.error("Failed to send special invitation image:", error);
        throw error;
      }
    };

    // Function to send special invitation message to WhatsApp
    const sendSpecialInvitationMessage = async () => {
      try {
        await apiCaller({
          method: "post",
          url: `/audience/send-special-invitation-message-to-whatsapp/${audienceData?._id}`,
          params: null,
          data: {
            components: {},
          },
        });
        return true;
      } catch (error) {
        console.error("Failed to send special invitation message:", error);
        throw error;
      }
    };

    const sendToWhatsapp = async () => {
      if (qrPassRef.current === null) return;

      try {
        setWaLoading(true);

        const qrPassImageUrl = await getOrGenerateQRPassImageUrl();

        if (!qrPassImageUrl) {
          toast.error("Unable to send to whatsapp.");
          setWaLoading(false);
          return;
        }

        // Send to WhatsApp using the QR pass image URL (either existing or newly uploaded)
        // This uses the existing endpoint structure with qr parameter
        await apiCaller({
          method: "post",
          url: `audience/sent-to-whatsapp/${audienceData?._id}`,
          params: null,
          data: {
            qr: qrPassImageUrl,
            imageOnly: true,
          },
        });

        setWaLoading(false);
      } catch (error) {
        setWaLoading(false);
        console.error("Failed to send to WhatsApp:", error);
        toast.error("Failed to send to WhatsApp.");
      }
    };

    // Helper function to add delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const sendWhatsAppInvitation = async () => {
      if (qrPassRef.current === null || invitationLoading) return;

      try {
        setInvitationLoading(true);

        // 1st message: Send special invitation image
        await sendSpecialInvitationImage();

        // Wait 1 second before next message
        await delay(1000);

        // 2nd message: Send special invitation message
        // await sendSpecialInvitationMessage();

        // // Wait 1 second before next message
        // await delay(1000);

        // 3rd message: Send QR image - same as "Send on WhatsApp" button but with imageOnly: true
        // First ensure QR image URL exists
        const qrPassImageUrl = await getOrGenerateQRPassImageUrl();

        if (!qrPassImageUrl) {
          toast.error("Unable to generate QR pass image.");
          setInvitationLoading(false);
          return;
        }

        // Send the QR image message with imageOnly parameter
        await apiCaller({
          method: "post",
          url: `/audience/sent-to-whatsapp/${audienceData?._id}`,
          params: null,
          data: {
            qr: qrPassImageUrl,
            imageOnly: true,
          },
        });

        setInvitationLoading(false);
        toast.success("Invitation sent over WhatsApp successfully");
      } catch (error) {
        setInvitationLoading(false);
        console.error("Failed to send WhatsApp invitation:", error);
        toast.error("Failed to send WhatsApp invitation.");
      }
    };

    const handleAddNewAudience = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();

      // Check if we're in edit mode (audience/edit route)
      if (location.pathname.includes("/audience/edit")) {
        // For edit flow, use window.location to avoid any React state conflicts
        window.location.href = "/audience/add";
      } else {
        // We're in add mode, refresh the page to start fresh
        window.location.reload();
      }
    };

    // const handlePrint = () => {
    //   if (!audienceData || !qr) return;
    //   // Find the QR SVG element rendered by react-qr-code
    //   const qrSvg = document.querySelector(".qr-placeholder svg");
    //   let qrDataUrl = "";

    //   if (qrSvg) {
    //     const serializer = new XMLSerializer();
    //     const svgString = serializer.serializeToString(qrSvg);
    //     const encodedData = window.btoa(unescape(encodeURIComponent(svgString)));
    //     qrDataUrl = `data:image/svg+xml;base64,${encodedData}`;
    //   }
    //   const printWindow = window.open("", "_blank", "width=400,height=600");
    //   const printHtml = `
    //     <html>
    //       <head>
    //         <title>Abhivyakti QR Pass</title>
    //         <style>
    //           body {
    //             font-family: Arial, sans-serif;
    //             color: #000;
    //             text-align: center;
    //             margin: 20px;
    //           }
    //           h2 {
    //             font-size: 18px;
    //             margin-bottom: 6px;
    //           }
    //           h3 {
    //             font-size: 14px;
    //             font-weight: normal;
    //             margin-bottom: 16px;
    //           }
    //           .guest-name {
    //             font-size: 16px;
    //             font-weight: bold;
    //             margin-bottom: 20px;
    //           }
    //           .qr-container {
    //             display: flex;
    //             justify-content: center;
    //             align-items: center;
    //             margin-top: 10px;
    //           }
    //           img {
    //             width: 120px;
    //             height: 120px;
    //             filter: grayscale(100%) contrast(150%);
    //           }
    //           @media print {
    //             body {
    //               -webkit-print-color-adjust: exact;
    //               print-color-adjust: exact;
    //             }
    //             button { display: none; }
    //           }
    //         </style>
    //       </head>
    //       <body>
    //         <h2>Abhivyakti QR Pass</h2>
    //         <h3>Ticket ID: ${ticketId || ""}</h3>
    //         <div class="guest-name">${
    //           fullName || audienceData?.firstname || ""
    //         }</div>
    //         ${
    //           memberCount && memberCount > 0
    //             ? `<div>+ ${memberCount} ${
    //                 memberCount > 1 ? "Members" : "Member"
    //               }</div>`
    //             : ""
    //         }
    //          <div class="qr-container">
    //           ${
    //             qrDataUrl
    //               ? `<img src="${qrDataUrl}" alt="QR Code" />`
    //               : "<p>[QR Code Missing]</p>"
    //           }
    //         </div>
    //         <script>
    //           window.onload = function() {
    //             window.print();
    //             window.onafterprint = () => window.close();
    //           }
    //         </script>
    //       </body>
    //     </html>
    //   `;

    //   printWindow.document.open();
    //   printWindow.document.write(printHtml);
    //   printWindow.document.close();
    // };

    const handlePrint = () => {
      if (!audienceData || !qr) return;

      // Try to extract the rendered QR SVG (from react-qr-code)
      const qrSvg = document.querySelector(".qr-placeholder svg");
      let qrDataUrl = "";

      if (qrSvg) {
        // Serialize and create an image data URL. We'll also specify a viewBox scale for better print resolution.
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(qrSvg);

        // Add explicit width/height attributes to ensure consistent printed size.
        // We set 360px width so printed QR is large and crisp. You can change this number.
        let svgWithSize = svgString;
        if (!/width=/.test(svgWithSize)) {
          svgWithSize = svgWithSize.replace(
            /<svg([^>]*)>/,
            `<svg$1 width="360" height="360" viewBox="0 0 ${
              qrSvg.viewBox.baseVal.width || 256
            } ${qrSvg.viewBox.baseVal.height || 256}">`
          );
        }

        const encodedData = window.btoa(
          unescape(encodeURIComponent(svgWithSize))
        );
        qrDataUrl = `data:image/svg+xml;base64,${encodedData}`;
      }

      // Header logo sources - customize these variables if you store logos in redux or props.
      // Fallback to bannerImg (imported) if you don't provide logos.
      const leftLogo = logoImg;
      const rightLogo = torentImg;

      const titleLine1 = "Welcome to the";
      const titleLine2 = "Abhivyakti City Arts Project - Edition 7";
      const footerNote =
        "Show your QR Pass to enter the main gate and performance venues.";

      const printWindow = window.open("", "_blank");
      const printHtml = `
    <html>
      <head>
        <title>Abhivyakti QR Pass</title>
        <meta name="viewport" content="width=device-width,initial-scale=1">
        <style>
          /* Reset */
          * { box-sizing: border-box; }

          body {
            // margin: 0;
            // padding: 12px;
            background: #f0f0f0;
            font-family: "Inter", "Arial", sans-serif;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .ticket {
            width: 320px; 
            margin: 12px auto;
            background: #ffffff;
            border: 1px solid #000000;
            padding: 18px 18px 24px;
            text-align: center;
            color: #000;
          }

          .logos {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 16px;
            gap: 18px;
          }

          .logos img {
            height: 40px;
            max-width: 48%;
            object-fit: contain;
            // filter: contrast(115%) brightness(1.1);
            // image-rendering: crisp-edges;
            // image-rendering: -webkit-optimize-contrast;
          }
          
          .title {
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 6px;
          }

          .subtitle {
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 12px;
          }

          .divider {
            height: 1px;
            background: #000000;
            margin: 8px 0 14px;
          }

          .ticket-id {
            font-size: 12px;
            margin-bottom: 8px;
            letter-spacing: 0.6px;
            margin: 15px 0px;
          }

          .guest-name {
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 6px;
          }

          .member-count {
            font-size: 14px;
            margin-bottom: 10px;
          }

          .qr-wrap {
            width: 240px;
            height: 190px;
            display:flex;
            align-items:center;
            justify-content:center;
            background: #fff;
          }

          .qr-wrap img {
            width: 180px;
            height: 180px;
            object-fit: contain;
          }

          .bottom-divider {
            height: 1px;
            background: #000000;
            margin: 14px 0 12px;
          }

          .footer-note {
            font-size: 10px;
            color: #000000;
            line-height: 1.3;
            margin-bottom: 10px;
          }

          @media print {
            body { background: #fff; margin: 0; padding: 0; }
            .ticket { border: none; box-shadow: none; margin: 0; width: 100%; }
            @page { margin: 0; }
          }
        </style>
      </head>
      <body>
        <div class="ticket">
          <div class="logos">
          <img src="${rightLogo}" alt="right logo" class="right-logo" />
          <img src="${leftLogo}" alt="left logo" />
          </div>
          <div class="divider"></div>
          <div class="subtitle">${titleLine2}</div>

          <div class="divider"></div>
          
          <div class="guest-name">${
            fullName || audienceData?.firstname || ""
          }</div>
          ${
            memberCount != null && memberCount > 0
              ? `<div class="guest-name">+ ${memberCount} ${
                  memberCount > 1 ? "Members" : "Member"
                }</div>`
              : ""
          }

          <div>
          <div class="ticket-id">Ticket ID : <strong>${
            ticketId || ""
          }</strong></div>
          </div>

          <div class="qr-wrap">
            ${
              qrDataUrl
                ? `<img src="${qrDataUrl}" alt="QR Code" />`
                : "<div style='font-size:12px;color:#c00;'>[QR Missing]</div>"
            }
          </div>

          <div class="bottom-divider"></div>

          <div class="footer-note">${footerNote}</div>
        </div>
      </body>
    </html>
  `;

      // Write and trigger print
      printWindow.document.open();
      printWindow.document.write(printHtml);
      printWindow.document.close();

      // Wait for load then print and close
      printWindow.onload = function () {
        try {
          printWindow.focus();
          printWindow.print();
        } catch (e) {
          console.warn("Print failed", e);
        }
        // close after a short delay to ensure print dialog opened
        setTimeout(() => {
          printWindow.close();
        }, 600);
      };
    };

    return (
      <>
        <div
          className="qr-pass"
          ref={qrPassRef}
          style={{ backgroundColor: backgroundColor }}
        >
          {/* Top Header with Title */}
          <div className="qr-pass-header">
            <h2>
              <span className="qr_heading">Abhivyakti QR Pass</span>
            </h2>
          </div>

          {/* Banner Image Section */}
          <div className="qr-pass-banner">
            {customImage ? (
              previewImageUrl ? (
                <img
                  src={getImageUrl(previewImageUrl)}
                  className="image-qr-banner"
                  alt="Custom Banner"
                />
              ) : (
                <div
                  className="text-center py-5"
                  style={{ border: "2px solid #fff", borderRadius: "8px" }}
                >
                  <p>Upload image (1080px X 1929px)</p>
                </div>
              )
            ) : data?.qr_pass_brand_image ? (
              <img
                src={getImageUrl(data?.qr_pass_brand_image)}
                className="image-qr-banner"
              />
            ) : null}
          </div>

          {/* Body: Info + QR Placeholder */}
          <div className="qr-pass-body">
            <div className="info-block">
              <div
                className="name-members"
                style={{
                  lineHeight:
                    audienceData?.audience_type === "group" ? "1.1" : "normal",
                  color:
                    audienceData?.audience_type === "group"
                      ? "#8B1E1E"
                      : "#3A2625",
                }}
              >
                {/* Organization name for group audience type only */}
                {audienceData?.audience_type === "group" &&
                  audienceData?.organization_name && (
                    <div
                      className="organization-name"
                      style={{
                        fontSize: `${orgNameFontSize}px`,
                        fontWeight: "normal",
                        color: "#8B1E1E",
                        marginBottom: "2.5px",
                        lineHeight: "1.2",
                        maxWidth: "110px",
                        wordWrap: "break-word",
                        display: "-webkit-box",
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {audienceData.organization_name}
                    </div>
                  )}
                <span className={`${nameLineClass}`}>{fullName}</span>
                {memberCount != null && memberCount > 0 ? (
                  <div>
                    + {memberCount} {memberCount > 1 ? "Members" : "Member"}
                  </div>
                ) : null}
              </div>
              <div
                className="ticket-id"
                style={{
                  color:
                    audienceData?.audience_type === "group"
                      ? "#8B1E1E"
                      : "#6B6B6B",
                }}
              >
                Ticket ID{" "}
                <span
                  className="ticket-code"
                  style={{
                    color:
                      audienceData?.audience_type === "group"
                        ? "#8B1E1E"
                        : "#000000",
                  }}
                >
                  {ticketId}
                </span>
              </div>
            </div>
            <div className="qr-placeholder">
              <QRCode value={qr} size={71} />
            </div>
          </div>

          {/* Footer Text */}
          <div className="qr-pass-footer">
            Show Your QR Pass at the Gates and Show Entrances to
            <br />
            Get a Smooth Entry to all Abhivyakti Shows
          </div>
        </div>
        {allowBtns ? (
          <>
            <button
              onClick={handleDownload}
              className="d-flex align-items-center custom-qr-btn bg-transparent"
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
              ) : (
                <>
                  <span>{btnTxt}</span>
                  <MyIcon />
                </>
              )}
              {/* <img src={send} alt="send-icon" className="send-icon" /> */}
            </button>

            <button
              onClick={sendToWhatsapp}
              className="d-flex align-items-center custom-qr-btn bg-transparent"
            >
              {waloading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
              ) : (
                <>
                  <span>Send on WhatsApp</span>
                  <SendIcon />
                </>
              )}
              {/* <img src={send} alt="send-icon" className="send-icon" /> */}
            </button>

            {/* <button
              onClick={sendWhatsAppInvitation}
              disabled={invitationLoading}
              className="d-flex align-items-center custom-qr-btn"
              style={{
                backgroundColor: "#1c9e30",
                color: "#ffffff",
                border: "none",
                cursor: invitationLoading ? "not-allowed" : "pointer",
                opacity: invitationLoading ? 0.7 : 1,
              }}
            >
              {invitationLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                  style={{ color: "#ffffff" }}
                />
              ) : (
                <span>Send WhatsApp Invitation</span>
              )}
            </button> */}

            <button
              onClick={handlePrint}
              className="d-flex align-items-center custom-qr-btn"
              style={{
                backgroundColor: "#007bff",
                color: "#ffffff",
                border: "none",
                cursor: "pointer",
              }}
            >
              <span>Print QR Pass</span>
            </button>

            {/* Add New Audience Button */}
            <button
              type="button"
              onClick={handleAddNewAudience}
              className="btn btn-primary"
              style={{
                backgroundColor: "#991b20",
                borderColor: "#991b20",
                color: "#fff",
                fontWeight: "600",
                height: "46px",
                borderRadius: "8px",
                width: "269px", // Match QR pass width exactly
                marginTop: "18px", // 3x the current mt-2 (6px)
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              + Add New Audience
            </button>
          </>
        ) : null}
      </>
    );
  }
);

QrPass.displayName = "QrPass";

export default QrPass;
